import { Label } from '@servicetim/ui/components';
import { cn } from '@servicetim/ui/lib';
import type { ReactNode } from 'react';

export interface FormRowProps {
  label: ReactNode;
  htmlFor?: string;
  /** Helper text under the control. */
  hint?: ReactNode;
  error?: ReactNode;
  required?: boolean;
  /** Control and label side by side (checkbox/switch rows). */
  inline?: boolean;
  className?: string;
  children: ReactNode;
}

/** Label + control + hint + error with the aria wiring, for hand-written (non-schema) forms. */
export function FormRow({
  label,
  htmlFor,
  hint,
  error,
  required,
  inline = false,
  className,
  children,
}: FormRowProps) {
  const labelNode = (
    <Label htmlFor={htmlFor}>
      {label}
      {required ? (
        <span aria-hidden="true" className="text-red-600 dark:text-red-400">
          *
        </span>
      ) : null}
    </Label>
  );
  return (
    <div className={cn('space-y-1.5', className)} data-slot="form-row">
      {inline ? (
        <div className="flex items-center gap-2">
          {children}
          {labelNode}
        </div>
      ) : (
        <>
          {labelNode}
          {children}
        </>
      )}
      {hint ? <p className="text-fg-muted text-xs">{hint}</p> : null}
      {error ? (
        <p role="alert" className="text-red-600 dark:text-red-400 text-xs">
          {error}
        </p>
      ) : null}
    </div>
  );
}
